
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");


import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType, otherPartyInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { getYourInformationResults, getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';
import { getWrittenResponseApplications } from '@/components/utils/ReplyPathways';

import { form19DataInfoType, writtenResponseOtherPartyDataInfoType } from '@/types/Application/WrittenResponse/PDF';
import { aboutWrittenResponseOrderSurveyDataInfoType, agreeDisagreeSurveyDataInfoType, wrReplyingToApplicationSurveyDataInfoType } from '@/types/Application/WrittenResponse';

@Component({
    components:{
        UnderlineForm,
        CheckBox        
    }
})

export default class Form19Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;

    @applicationState.State
    public types!: string[];    

    dataReady = false;  
   
    yourInfo = {} as yourInformationInfoDataInfoType;
    wrInfo = {} as form19DataInfoType;
    
    existingFileNumber = '';
    filingLocationReason = '';  
    
    
    otherParties: string[] = [];
    otherPartyInfo = [];
    

    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    }
   
    public extractInfo(){
        this.yourInfo = this.getYourInfo();
        this.otherPartyInfo = this.getOtherPartyInfo();
        this.wrInfo = this.getWrInfo();
        this.existingFileNumber = getLocationInfo(this.result.filingLocationSurvey);
    }

    public getYourInfo(){           

        if(this.result?.yourInformationSurvey){
            return getYourInformationResults(this.result?.yourInformationSurvey); 
        } 
        else
            return {} as yourInformationInfoDataInfoType
    }

    public getOtherPartyInfo(){

        let OpInformation: writtenResponseOtherPartyDataInfoType[] = [];        

        if (this.result?.otherPartyCommonSurvey?.length > 0){
            
            OpInformation = [];
            const otherPartyData: otherPartyInfoType[] =  this.result.otherPartyCommonSurvey;
           
            for(const party of otherPartyData){ 
                const otherParty = {} as writtenResponseOtherPartyDataInfoType;

                if (party.name)
                    otherParty.name = party.name;
                
                OpInformation.push(otherParty)
            }
        } 

        return OpInformation
    }
    
    public getWrInfo() {

        const wrInformation = {} as form19DataInfoType;

        wrInformation.caseList = getWrittenResponseApplications(this.types);
       

        wrInformation.applicationsList = (wrInformation.caseList)?wrInformation.caseList.join(' and '):'';

        wrInformation.otherPartiesList = '';
        wrInformation.applicationFiledOn = '';

        if (this.result.wrReplyingToApplicationSurvey) {
            const wrReplyingToApplicationData: wrReplyingToApplicationSurveyDataInfoType = this.result.wrReplyingToApplicationSurvey;
            const applicants = [];

            for (const applicant of wrReplyingToApplicationData.partiesMakingApplication){

                if (applicant == "other"){
                    if (wrReplyingToApplicationData.partiesMakingApplicationComment){
                        applicants.push(wrReplyingToApplicationData.partiesMakingApplicationComment)
                    }
                } else {
                    applicants.push(applicant)

                }
            }
            
            wrInformation.otherPartiesList = applicants.join(', ');
            wrInformation.applicationFiledOn = wrReplyingToApplicationData.applicationFiledOn;
        }

        wrInformation.orderFacts = '';
        wrInformation.orderDetails = '';
        

        if (this.result.aboutWrittenResponseOrderSurvey) {
            const aboutWrOrderData: aboutWrittenResponseOrderSurveyDataInfoType = this.result.aboutWrittenResponseOrderSurvey;
            if (aboutWrOrderData.requiredChanges == 'y'){
                wrInformation.orderDetails = aboutWrOrderData.orderDescription;
                wrInformation.orderFacts = aboutWrOrderData.applicationFacts;
            }
        }

        wrInformation.agreed = false;
        wrInformation.disagree = false;
        wrInformation.partialagreed = false;
        wrInformation.partialdisagree = false;
        wrInformation.agreeAdditionalDetailsYesNo = false;
        wrInformation.agreeDetails = '';
        wrInformation.disagreeDetails = '';
        wrInformation.agreeAdditionalDetails = '';
        wrInformation.disAgreeDetailsOtherParty = '';

        if (this.result.agreeDisagreeSurvey) {
            const agreeDisagreeData: agreeDisagreeSurveyDataInfoType = this.result.agreeDisagreeSurvey;
            wrInformation.agreed = agreeDisagreeData.agreeDisagree.includes('agree');
            wrInformation.disagree = agreeDisagreeData.agreeDisagree.includes('disagree');
            wrInformation.partialagreed = agreeDisagreeData.agreeDisagree.includes('partialagree');
            wrInformation.partialdisagree = agreeDisagreeData.agreeDisagree.includes('partialdisagree');
            wrInformation.agreeAdditionalDetailsYesNo = agreeDisagreeData.agreeAdditionalDetailsYesNo && agreeDisagreeData.agreeAdditionalDetailsYesNo.includes('y');
            
            if (wrInformation.agreed){
                wrInformation.agreeDetails = agreeDisagreeData.agreeDetails;
                if (wrInformation.agreeAdditionalDetailsYesNo){
                    wrInformation.agreeAdditionalDetails = agreeDisagreeData.agreeAdditionalDetails;
                }
            }
            if (wrInformation.disagree){
                wrInformation.disagreeDetails = agreeDisagreeData.disAgreeDetails;
                wrInformation.disAgreeDetailsOtherParty = agreeDisagreeData.disAgreeDetailsOtherParty;
            }            
        }

       
        return wrInformation;
    }
 
}

